import CustomModal from '@src/components/Elements/CustomModal/CustomModal'
import Bounty from '../Bounty/Bounty'
import { useBounties } from '@src/context/BountiesContext'
import CountdownTimer from '@src/components/Elements/CountdownTimer'
import useIsMobile from '@src/hooks/IsMobile'
import ProgressBar from '@src/components/AppNavigation/components/ProgressMenuItem/ProgressBar/ProgressBar'
import Divider from '@src/components/Elements/Divider'
import SocialButtons from '@src/components/Elements/SocialButtons/SocialButtons'
import { t } from 'i18next'
import {
  Heading,
  ModalContent,
  ProgressBarWrap,
  SocialSection,
  SocialSectionHeading,
  TimerWrapper,
} from './BountyProgressModal.styled'
import GradientButton from '@src/components/Elements/GradientButton/GradientButton'

interface BountyProgressModalProps {
  modalVisible: boolean
  setModalVisible: (isVisible: boolean) => void
}

const BountyProgressModal = ({ modalVisible, setModalVisible }: BountyProgressModalProps) => {
  const isMobile = useIsMobile()
  const { bonus, bountyProgress, expiresStamp, claimPrize, refetchCampaigns, fetchBounties } = useBounties()

  const claimBountyHandler = () => {
    if (!bonus?.amount || !bonus?.campaign?.virtualId) return
    claimPrize(bonus.amount, bonus.campaign.virtualId)

    setModalVisible(false)

    // update bounty menu items and bounties list
    setTimeout(() => {
      refetchCampaigns()
      fetchBounties()
    }, 2000)
  }

  const showClaim = bonus?.meta?.finished && bonus?.meta?.bounty

  if (!bonus) return null

  return (
    <CustomModal
      isOpen={modalVisible}
      onClose={() => setModalVisible(false)}
      heading={'ACTIVE BOUNTY'}
      customWidth={isMobile ? '98%' : '400px'}
    >
      <ModalContent>
        <div className="relative">
          <Bounty
            bountyId={bonus?.campaign?.meta.title}
            bgImageUrl={bonus?.campaign?.meta.bg_image_url || 'https://cdn.blackjack.fun/optimized/bounties/level1.webp'}
            title={bonus?.campaign?.meta.title}
            rating={bonus?.campaign?.meta.rating}
            subtitle={bonus?.campaign?.meta.subtitle}
            disabled={false}
            status={'ACTIVE'}
            expires={null}
            showOnlyInfo={true}
            availableBountiesCount={null}
          />
        </div>
        <Divider />
        <Heading>PROGRESS</Heading>
        <ProgressBarWrap>
          <ProgressBar $progress={bountyProgress} height="13px" />
        </ProgressBarWrap>
        <Divider />
        {showClaim ? (
          <GradientButton onClickAction={claimBountyHandler} name="Claim Your Bounty Now" />
        ) : (
          <>
            <Heading>TIME REMAINING</Heading>
            <TimerWrapper>
              <CountdownTimer expiresAt={expiresStamp} />
            </TimerWrapper>
          </>
        )}

        <Divider />
        <SocialSection>
          <SocialSectionHeading>{t('footer.joinCommunity', 'Join the Community')}</SocialSectionHeading>
          <SocialButtons
            twitterUrl="https://twitter.com/blackjack_fun"
            discordUrl="https://discord.gg/c93ZXs6Dsh"
            telegramUrl="https://t.me/Blackjack_fun_Official"
            facebookUrl="https://www.facebook.com/Blackjackfun-689594501908642"
            instagramUrl="https://www.instagram.com/blackjack.fun/"
          />
        </SocialSection>
      </ModalContent>
    </CustomModal>
  )
}

export default BountyProgressModal
